module.exports = __webpack_public_path__ + "img/login_update.3697ff8c.png";